@if (showDetailsScreen) {
  <div class="aems-bread-crumb m-b-16">
    <a class="m-r-4" routerLink="/master-data">Master Data</a><span class="m-r-4">/ </span
    ><a class="m-r-4" routerLink="/master-data/parts-management">Parts Management</a><span>/ {{ id }}</span>
  </div>
  <div class="m-b-12" style="display: flex; align-items: center; gap: 12px">
    <h3>{{ id }}</h3>

    <div style="display: flex; flex-grow: 1; justify-content: end; gap: 8px">
      @if (authPolicy.canEditPartManagement && partsManagement) {
        <mc-button data-cy="edit" fit="small" variant="outlined" icon="pencil" (click)="onEditClicked()" (keydown.enter)="onEditClicked()">
          Edit
        </mc-button>
      }

      @if (authPolicy.canViewPartManagement && partsManagement) {
        <mc-button
          data-cy="audit-log"
          fit="small"
          variant="outlined"
          icon="arrow-anti-clockwise-clock"
          [loading]="auditlogApiCallStatus === 'IN_PROGRESS'"
          (click)="onAuditLogClicked()"
          (keydown.enter)="onAuditLogClicked()">
          Audit Log
        </mc-button>
      }
    </div>
  </div>
  @if (partsManagement?.updatedAt && partsManagement?.updatedBy) {
    <p class="mds-text--body-normal mds-neutral--weak__text-color m-b-12">
      Last updated on {{ partsManagement!.updatedAt | date: "d MMM yyyy 'at' HH:mm:ss" }} by {{ partsManagement!.updatedBy }}
    </p>
  }

  @if (viewDataApiCalls === 'COMPLETED_SUCCESFULLY') {
    @if (partsManagement) {
      <div class="pure-g" style="align-items: stretch">
        <div class="pure-u-1 pure-u-md-1 pure-u-lg-1 pure-u-xl-2-3" style="display: flex; flex-direction: column">
          <app-parts-management-header [partsManagementHeader]="partsManagement"></app-parts-management-header>
        </div>
        <div class="pure-u-1 pure-u-md-1 pure-u-lg-1 pure-u-xl-1-3 xl-only-style" style="display: flex; flex-direction: column">
          <app-parts-management-cost-details [partsManagementCostDetails]="partsManagement"></app-parts-management-cost-details>
        </div>
      </div>
      <app-parts-management-operational-settings
        [partsManagementOperationalSettings]="partsManagement"></app-parts-management-operational-settings>
      <app-parts-management-comments [partsManagementComments]="partsManagement"></app-parts-management-comments>
    }
  }

  @if (viewDataApiCalls === 'IN_PROGRESS') {
    <div class="aems-card m-t-36">
      <div class="pure-g">
        @for (x of '1234567890'; track $index) {
          <div class="pure-u-md-8-24 pure-u-lg-4-24 p-b-16 p-r-8">
            <app-loader height="40px"></app-loader>
          </div>
        }
      </div>
    </div>
    <div class="aems-card m-t-12">
      <div class="pure-g">
        @for (x of '123456789'; track $index) {
          <div class="pure-u-md-8-24 pure-u-lg-4-24 p-b-16 p-r-8">
            <app-loader height="40px"></app-loader>
          </div>
        }
      </div>
    </div>
  }

  @if (viewDataApiCalls === 'FAILED') {
    <div class="aems-card m-t-36">
      <div class="pure-g">
        <div class="pure-u-md-24-24 text-align-center">
          <p class="mds-text--body-large">Failed to load parts management details</p>
          <mc-button fit="small" variant="filled" appearance="primary" class="m-t-16" (click)="ngOnInit()" (keydown.enter)="ngOnInit()"
            >Retry</mc-button
          >
        </div>
      </div>
    </div>
  }
}

<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="small" dimension="large" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <app-master-data-audit-log [transactionCode]="partsManagement?.partCode" [label]="'Part Code'" [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
